import _defineProperty from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { get as e, omit as r, pick as t, isFunction as a } from "@vtex/admin-ui-util";
import { createStitches as i } from "@stitches/react";
var n = {
  transparent: "transparent",
  white: "#FFFFFF",
  black: "#000000",
  blue05: "#F1F4FC",
  blue10: "#DDE5F7",
  blue20: "#BBCBF0",
  blue30: "#96B2F2",
  blue40: "#2953B2",
  blue50: "#20408C",
  blue60: "#172F66",
  lightBlue05: "#EDF5FB",
  lightBlue10: "#DEECF7",
  lightBlue20: "#B9DAF3",
  lightBlue30: "#7CBBEA",
  lightBlue40: "#2978B5",
  lightBlue50: "#216090",
  lightBlue60: "#143C5C",
  red05: "#FBF2F2",
  red10: "#F8E3E3",
  red20: "#EDBABA",
  red30: "#F49494",
  red40: "#CC3D3D",
  red50: "#962828",
  red60: "#782020",
  green05: "#ECF7EC",
  green10: "#DFF1E0",
  green20: "#AEDDB0",
  green30: "#83D187",
  green40: "#38853C",
  green50: "#285F2B",
  green60: "#1C431E",
  orange05: "#FFF5EC",
  orange10: "#FFEBD7",
  orange20: "#FFCD9B",
  orange30: "#F5AE70",
  orange40: "#D56A00",
  orange50: "#A65200",
  orange60: "#5C2C00",
  cyan05: "#EFF9FB",
  cyan10: "#D5EFF4",
  cyan20: "#A4DEE9",
  cyan30: "#63CBDB",
  cyan40: "#1C99A8",
  cyan50: "#207883",
  cyan60: "#093F46",
  purple05: "#F6F3FA",
  purple10: "#EDE8F4",
  purple20: "#D3C4E4",
  purple30: "#C6A5EA",
  purple40: "#835AB3",
  purple50: "#684391",
  purple60: "#462D63",
  pink05: "#FBF2F5",
  pink10: "#F5E0E7",
  pink20: "#EAB2C4",
  pink30: "#F48AAB",
  pink40: "#DA3561",
  pink50: "#B1204B",
  pink60: "#850D35",
  teal05: "#E8F7F3",
  teal10: "#CDEFE7",
  teal20: "#A6E0D2",
  teal30: "#66CBB7",
  teal40: "#007969",
  teal50: "#006053",
  teal60: "#00463C",
  gray05: "#F4F4F4",
  gray10: "#E6E6E6",
  gray20: "#DDDDDD",
  gray30: "#B9B9B9",
  gray40: "#747474",
  gray50: "#545454",
  gray60: "#3B3B3B",
  grayTransparent05: "rgba(0, 0, 0, 0.05)",
  grayTransparent10: "rgba(0, 0, 0, 0.1)",
  grayTransparent20: "rgba(0, 0, 0, 0.2)",
  grayTransparent30: "rgba(0, 0, 0, 0.3)",
  grayTransparent40: "rgba(0, 0, 0, 0.4)",
  grayTransparent50: "rgba(0, 0, 0, 0.5)",
  grayTransparent60: "rgba(0, 0, 0, 0.6)",
  grayTransparent70: "rgba(0, 0, 0, 0.7)",
  grayTransparent80: "rgba(0, 0, 0, 0.8)",
  grayTransparent90: "rgba(0, 0, 0, 0.9)"
},
    o = Object.assign(Object.assign({}, n), {
  primary: n.white,
  secondary: n.gray05,
  disabled: n.gray10,
  positive: n.green10,
  critical: n.red10,
  warning: n.orange10,
  info: n.lightBlue10,
  inverted: n.black,
  overlay: n.grayTransparent50,
  skeleton: "linear-gradient(90deg, transparent, ".concat(n.gray10, ", transparent)"),
  action: {
    neutral: {
      secondary: n.gray05,
      secondaryHover: n.gray10,
      secondaryPressed: n.gray20,
      tertiary: "transparent",
      tertiaryHover: n.grayTransparent05,
      tertiaryPressed: n.grayTransparent10
    },
    main: {
      primary: n.blue40,
      primaryHover: n.blue50,
      primaryPressed: n.blue60,
      secondary: n.blue10,
      secondaryHover: n.blue20,
      secondaryPressed: n.blue30,
      tertiary: "transparent",
      tertiaryHover: n.blue05,
      tertiaryPressed: n.blue10,
      tertiarySelected: n.blue05
    },
    critical: {
      primary: n.red40,
      primaryHover: n.red50,
      primaryPressed: n.red60,
      secondary: n.red10,
      secondaryHover: n.red20,
      secondaryPressed: n.red30,
      tertiary: "transparent",
      tertiaryHover: n.red05,
      tertiaryPressed: n.red10,
      tertiarySelected: n.red05
    }
  },
  form: {
    neutral: "transparent",
    neutralHover: n.gray10,
    neutralPressed: n.gray30,
    neutralChecked: n.black,
    neutralCheckedHover: n.gray60,
    neutralCheckedPressed: n.gray50,
    neutralInactive: n.gray30,
    neutralInactiveHover: n.gray50,
    neutralInactivePressed: n.gray60,
    neutralActive: n.black,
    neutralActiveHover: n.gray60,
    neutralActivePressed: n.gray50,
    controlHover: "transparent",
    controlChecked: n.blue40,
    controlCheckedHover: n.blue50,
    controlCheckedFocus: n.blue50,
    controlActive: n.green40,
    controlActiveHover: n.green50,
    controlInactive: n.gray30,
    controlInactiveHover: n.gray40
  }
}),
    s = ["main", "critical", "info", "warning", "positive", "neutral"],
    c = {
  critical: "red",
  warning: "orange",
  positive: "green",
  neutral: "gray",
  info: "lightBlue",
  main: "blue"
};

function l(e) {
  return e;
}

var d = ["$white", "$black", "$blue05", "$blue10", "$blue20", "$blue30", "$blue40", "$blue50", "$blue60", "$lightBlue05", "$lightBlue10", "$lightBlue20", "$lightBlue30", "$lightBlue40", "$lightBlue50", "$lightBlue60", "$red05", "$red10", "$red20", "$red30", "$red40", "$red50", "$red60", "$green05", "$green10", "$green20", "$green30", "$green40", "$green50", "$green60", "$orange05", "$orange10", "$orange20", "$orange30", "$orange40", "$orange50", "$orange60", "$cyan05", "$cyan10", "$cyan20", "$cyan30", "$cyan40", "$cyan50", "$cyan60", "$purple05", "$purple10", "$purple20", "$purple30", "$purple40", "$purple50", "$purple60", "$pink05", "$pink10", "$pink20", "$pink30", "$pink40", "$pink50", "$pink60", "$teal05", "$teal10", "$teal20", "$teal30", "$teal40", "$teal50", "$teal60", "$gray05", "$gray10", "$gray20", "$gray30", "$gray40", "$gray50", "$gray60", "$grayTransparent05", "$grayTransparent10", "$grayTransparent20", "$grayTransparent30", "$grayTransparent40", "$grayTransparent50", "$grayTransparent60", "$grayTransparent70", "$grayTransparent80", "$grayTransparent90"],
    g = [].concat(d, ["$primary", "$secondary", "$disabled", "$positive", "$critical", "$warning", "$info", "$inverted", "$overlay", "$skeleton", "$action.neutral.tertiary", "$action.neutral.tertiaryHover", "$action.neutral.tertiaryPressed", "$action.main.primary", "$action.main.primaryHover", "$action.main.primaryPressed", "$action.main.secondary", "$action.main.secondaryHover", "$action.main.secondaryPressed", "$action.main.tertiary", "$action.main.tertiaryHover", "$action.main.tertiaryPressed", "$action.main.tertiarySelected", "$action.critical.primary", "$action.critical.primaryHover", "$action.critical.primaryPressed", "$action.critical.secondary", "$action.critical.secondaryHover", "$action.critical.secondaryPressed", "$action.critical.tertiary", "$action.critical.tertiaryHover", "$action.critical.tertiaryPressed", "$action.critical.tertiarySelected", "$form.neutral", "$form.neutralHover", "$form.neutralPressed", "$form.neutralChecked", "$form.neutralCheckedHover", "$form.neutralCheckedPressed", "$form.neutralInactive", "$form.neutralInactiveHover", "$form.neutralInactivePressed", "$form.neutralActive", "$form.neutralActiveHover", "$form.neutralActivePressed", "$form.controlHover", "$form.controlChecked", "$form.controlCheckedHover", "$form.controlActive", "$form.controlActiveHover", "$form.controlInactive", "$form.controlInactiveHover"]),
    p = [].concat(d, ["$primary", "$secondary", "$disabled", "$inverted", "$positive", "$info", "$critical", "$warning", "$action.neutral.tertiary", "$action.neutral.tertiaryHover", "$action.neutral.tertiaryPressed", "$action.main.primary", "$action.main.primaryHover", "$action.main.primaryPressed", "$action.main.secondary", "$action.main.secondaryHover", "$action.main.secondaryPressed", "$action.main.tertiary", "$action.main.tertiaryHover", "$action.main.tertiaryPressed", "$action.main.tertiarySelected", "$action.critical.primary", "$action.critical.primaryHover", "$action.critical.primaryPressed", "$action.critical.secondary", "$action.critical.secondaryHover", "$action.critical.secondaryPressed", "$action.critical.tertiary", "$action.critical.tertiaryHover", "$action.critical.tertiaryPressed", "$action.critical.tertiarySelected", "$form.neutral", "$form.neutralChecked", "$form.controlChecked"]),
    m = ["$neutral", "$mainSelected", "$positive", "$info", "$critical", "$warning", "$disabled", "$form.neutral", "$form.neutralHover", "$form.neutralFocus", "$form.neutralPressed", "$form.neutralChecked", "$form.neutralCheckedHover", "$form.neutralCheckedPressed", "$form.critical", "$form.criticalHover", "$form.criticalFocus", "$form.control", "$form.controlHover", "$form.controlChecked", "$form.controlCheckedHover"],
    $ = ["$ring.critical", "$ring.neutral", "$ring.main", "$overlay.center", "$overlay.bottom"],
    u = ["$pageTitle", "$title1", "$title2", "$action1", "$action2", "$display", "$body", "$detail"],
    b = ["$space-0", "$space-05", "$space-1", "$space-2", "$space-3", "$space-4", "$space-5", "$space-6", "$space-7", "$space-8", "$space-10", "$space-12", "$space-16", "$space-20", "$space-24", "$space-28", "$space-32"],
    y = ["z-1", "z-2", "z-3", "z-4", "z-5", "z-6", "z-7", "z-8", "z-9", "z-10"],
    f = ["$none", "$pill", "$base"];

function h(r) {
  return "".concat("0rem 0rem 0rem 0.0625rem ".concat(e(n, "".concat(c[r], "05"))), ", ", "0rem 0rem 0rem 0.1875rem ".concat(e(n, "".concat(c[r], "30"))));
}

function v(r) {
  return {
    background: e(n, "".concat(r, "10"), ""),
    color: e(n, "".concat(r, "60"), "")
  };
}

function S(r) {
  return e(n, z(r), "");
}

function B(e) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  return {
    bg: "listBoxItem.".concat(e).concat(r ? "Selected" : ""),
    color: "listBoxItem.".concat(e).concat(r ? "Selected" : ""),
    ":hover": {
      bg: "listBoxItem.".concat(e, "Hover"),
      color: "listBoxItem.".concat(e, "Hover")
    },
    ":pressed": {
      bg: "listBoxItem.".concat(e, "Pressed"),
      color: "listBoxItem.".concat(e, "Pressed")
    }
  };
}

function k(e, r) {
  return {
    ":focus": Object.assign({
      outline: "none",
      boxShadow: h(e)
    }, null == r ? void 0 : r.focus),
    ":focus:not([data-focus-visible-added])": Object.assign({
      outline: "none",
      boxShadow: "none"
    }, null == r ? void 0 : r.polyfill)
  };
}

function H(r) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return "".concat(t, "px solid ").concat(e(n, z(r)));
}

function F(e, r) {
  return "number" == typeof e ? "".concat(e).concat(r) : "".concat(e);
}

function C(e) {
  return "string" == typeof e && e.startsWith("$");
}

function z(e) {
  return C(e) ? e.substring(1) : e;
}

var E = function E() {
  for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
    e[_key] = arguments[_key];
  }

  return e.join(" ");
},
    T = {
  neutral: H("$gray20"),
  mainSelected: H("$blue40", 2),
  positive: H("$green30"),
  info: H("$lightBlue30"),
  critical: H("$red30"),
  warning: H("$orange30"),
  disabled: H("$gray40"),
  form: {
    neutral: H("$gray30"),
    neutralHover: H("$gray50"),
    neutralFocus: H("$gray60"),
    neutralPressed: H("$gray60"),
    neutralChecked: H("$black"),
    neutralCheckedHover: H("$gray60"),
    neutralCheckedPressed: H("$gray50"),
    critical: H("$red40"),
    criticalHover: H("$red50"),
    criticalFocus: H("$red60"),
    control: H("$gray30"),
    controlHover: H("$gray50"),
    controlFocus: H("$gray50"),
    controlChecked: H("$blue40"),
    controlCheckedHover: H("$blue50"),
    controlCheckedFocus: H("$blue50")
  }
},
    U = {
  mobile: "40em",
  tablet: "48em",
  desktop: "64em",
  widescreen: "75em"
},
    W = Object.assign(Object.assign({}, n), {
  primary: n.black,
  secondary: n.gray50,
  disabled: n.gray40,
  inverted: n.white,
  positive: n.green40,
  info: n.lightBlue40,
  critical: n.red40,
  warning: n.orange40,
  action: {
    neutral: {
      tertiary: n.gray50,
      tertiaryHover: n.gray60,
      tertiaryPressed: n.black
    },
    main: {
      primary: n.white,
      primaryHover: n.white,
      primaryPressed: n.white,
      secondary: n.blue40,
      secondaryHover: n.blue50,
      secondaryPressed: n.blue60,
      tertiary: n.blue40,
      tertiaryHover: n.blue50,
      tertiaryPressed: n.blue60,
      tertiarySelected: n.blue40
    },
    critical: {
      primary: n.white,
      primaryHover: n.white,
      primaryPressed: n.white,
      secondary: n.red40,
      secondaryHover: n.red50,
      secondaryPressed: n.red60,
      tertiary: n.red40,
      tertiaryHover: n.red50,
      tertiaryPressed: n.red60,
      tertiarySelected: n.red40
    }
  },
  form: {
    neutral: n.black,
    neutralChecked: n.white,
    controlNeutral: n.black,
    controlChecked: n.white,
    control: n.white
  }
}),
    w = {
  "@font-face": {
    fontFamily: "VTEX Trust",
    fontDisplay: "swap",
    fontStyle: "normal",
    src: "url('https://io.vtex.com.br/fonts/vtex-trust/VTEXTrust-VF-May-5-2022.woff2')",
    unicodeRange: "U+0020-007E, U+00A0-0107, U+010A-0113, U+0116-011B,\n          U+011E-0123, U+0126-0127, U+012A-012B, U+012E-0131, U+0136-0137,\n          U+0139-0148, U+014A-014D, U+0150-015B, U+015E-0167, U+016A-016B,\n          U+016E-017E, U+0192, U+01EA-01EB, U+0218-021B, U+0237, U+02C6-02C7,\n          U+02D8-02DD, U+0300-0304, U+0306-0308, U+030A-030C, U+0312,\n          U+0326-0328, U+0335, U+0337-0338, U+0394, U+03A9, U+03BC, U+03C0,\n          U+0E3F, U+1E80-1E85, U+1E9E, U+1EF2-1EF3, U+2000-200B, U+2013-2014,\n          U+2018-201A, U+201C-201E, U+2020-2022, U+2026, U+202F-2030,\n          U+2032-2033, U+2039-203A, U+2044, U+205F, U+2070, U+2074-2079,\n          U+2080-2089, U+20A1, U+20A4, U+20A9-20AE, U+20B1, U+20B4, U+20B8-20BA,\n          U+20BF, U+2117, U+2122, U+215D, U+2202, U+220F, U+2211-2212, U+221A,\n          U+221E, U+222B, U+2248, U+2260, U+2264-2265, U+25CA, U+FB01-FB02"
  },
  body: {
    margin: "$space-0",
    bg: "$primary",
    color: "$primary"
  },
  "html, body": {
    text: "$body",
    fontSize: "100%",
    "-webkit-font-smoothing": "antialiased",
    "-moz-osx-font-smoothing": "grayscale"
  },
  "pre, code": {
    text: "$code"
  },
  "*": {
    text: "$body",
    "-webkit-font-smoothing": "antialiased",
    "-moz-osx-font-smoothing": "grayscale"
  },
  "*, ::before, ::after": {
    boxSizing: "border-box",
    borderWidth: 0,
    borderStyle: "solid"
  },
  "html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, a, abbr, acronym, address, big, cite, del, dfn, em, img, ins, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video": {
    margin: "$space-0",
    padding: "$space-0",
    border: 0,
    verticalAlign: "baseline"
  },
  "article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section": {
    display: "block"
  },
  "blockquote, q": {
    quotes: "none"
  },
  "blockquote:before, blockquote:after, q:before, q:after": {
    content: "''"
  },
  table: {
    borderCollapse: "collapse",
    borderSpacing: 0
  },
  "@tablet": {
    "blockquote:before, blockquote:after, q:before, q:after": {
      content: "none"
    }
  }
},
    A = {
  ring: {
    critical: h("critical"),
    neutral: h("neutral"),
    main: h("main")
  },
  overlay: {
    center: "0rem 0rem 1rem 0rem rgba(0,0,0,0.10)",
    bottom: "0rem 0rem 1.5rem 0rem rgba(0,0,0,0.05)"
  }
},
    P = '"VTEX Trust", -apple-system, system-ui, BlinkMacSystemFont, sans-serif',
    D = "'WGHT' 400, 'WDTH' 300",
    x = "'WGHT' 500, 'WDTH' 300",
    I = "0.875rem",
    R = "1rem",
    j = {
  pageTitle: {
    fontFamily: P,
    fontVariationSettings: D,
    fontSize: "1.25rem",
    lineHeight: 1.2,
    letterSpacing: "-0.004em"
  },
  title1: {
    fontFamily: P,
    fontVariationSettings: x,
    fontSize: R,
    lineHeight: 1.5,
    letterSpacing: "0em"
  },
  title2: {
    fontFamily: P,
    fontVariationSettings: D,
    fontSize: R,
    lineHeight: 1.5,
    letterSpacing: "0em"
  },
  action1: {
    fontFamily: P,
    fontVariationSettings: x,
    fontSize: I,
    lineHeight: 1.1428571429,
    letterSpacing: "0.01em"
  },
  action2: {
    fontFamily: P,
    fontVariationSettings: D,
    fontSize: I,
    lineHeight: 1.1428571429,
    letterSpacing: "0.01em"
  },
  display: {
    fontFamily: P,
    fontVariationSettings: x,
    fontSize: "1.5rem",
    lineHeight: 1.3333333333,
    letterSpacing: "-0.004em"
  },
  body: {
    fontFamily: P,
    fontVariationSettings: D,
    fontSize: "0.875rem",
    lineHeight: 1.4285714286,
    letterSpacing: "0.002em"
  },
  detail: {
    fontFamily: P,
    fontVariationSettings: D,
    fontSize: "0.75rem",
    lineHeight: 1.3333333333,
    letterSpacing: "0.004em"
  },
  code: {
    fontFamily: '"MonoLisa", "Operator Mono", "Fira Code Retina", "Fira Code", "FiraCode-Retina", "Dank Mono", "Consolas", "Monaco", "Menlo", monospace'
  }
},
    O = '"VTEX Trust", -apple-system, system-ui, BlinkMacSystemFont, sans-serif',
    V = {
  lineHeights: {
    pageTitle: 1.2,
    title1: 1.5,
    title2: 1.5,
    action1: 1.1428571429,
    action2: 1.1428571429,
    display: 1.3333333333,
    body: 1.4285714286,
    detail: 1.3333333333,
    code: "normal"
  },
  letterSpacings: {
    pageTitle: "-0.004em",
    title1: "0em",
    title2: "0em",
    action1: "0.01em",
    action2: "0.01em",
    display: "-0.004em",
    body: "0.002em",
    detail: "0.004em",
    code: "inherit"
  },
  fontWeights: {
    pageTitle: "'WGHT' 400, 'WDTH' 300",
    title1: "'WGHT' 500, 'WDTH' 300",
    title2: "'WGHT' 400, 'WDTH' 300",
    action1: "'WGHT' 500, 'WDTH' 300",
    action2: "'WGHT' 400, 'WDTH' 300",
    display: "'WGHT' 500, 'WDTH' 300",
    body: "'WGHT' 400, 'WDTH' 300",
    detail: "'WGHT' 400, 'WDTH' 300",
    code: "inherit"
  },
  fontSizes: {
    pageTitle: "1.25rem",
    title1: "1rem",
    title2: "1rem",
    action1: "0.875rem",
    action2: "0.875rem",
    display: "1.5rem",
    body: "0.875rem",
    detail: "0.75rem",
    code: "inherit"
  },
  fonts: {
    pageTitle: O,
    title1: O,
    title2: O,
    action1: O,
    action2: O,
    display: O,
    body: O,
    detail: O,
    code: '"MonoLisa", "Operator Mono", "Fira Code Retina", "Fira Code", "FiraCode-Retina", "Dank Mono", "Consolas", "Monaco", "Menlo", monospace'
  }
},
    G = Object.assign(Object.assign({
  colors: n,
  bg: o,
  border: T,
  borderRadius: {
    none: "0rem",
    base: "0.25rem",
    pill: "100%"
  },
  breakpoints: U,
  fg: W,
  global: w,
  shadow: A,
  sizes: {
    sm: "20rem",
    md: "48rem",
    lg: "56rem",
    xl: "64rem",
    "1/2": "50%",
    "1/4": "25%",
    "2/4": "50%",
    "3/4": "75%",
    "1/8": "12.5%",
    "2/8": "25%",
    "3/8": "37.5%",
    "4/8": "50%",
    "5/8": "62.5%",
    "6/8": "75%",
    "7/8": "87.5%",
    "1/12": "8.333333%",
    "2/12": "16.666667%",
    "3/12": "25%",
    "4/12": "33.333333%",
    "5/12": "41.666667%",
    "6/12": "50%",
    "7/12": "58.333333%",
    "8/12": "66.666667%",
    "9/12": "75%",
    "10/12": "83.333333%",
    "11/12": "91.666667%",
    full: "100%",
    screenHeight: "100vh",
    screenWidth: "100vw"
  },
  space: {
    "space-0": "0rem",
    "space-05": "0.125rem",
    "space-1": "0.25rem",
    "space-2": "0.5rem",
    "space-3": "0.75rem",
    "space-4": "1rem",
    "space-5": "1.25rem",
    "space-6": "1.5rem",
    "space-7": "1.75rem",
    "space-8": "2rem",
    "space-10": "2.5rem",
    "space-12": "3rem",
    "space-16": "4rem",
    "space-20": "5rem",
    "space-24": "6rem",
    "space-28": "7rem",
    "space-32": "8rem"
  },
  text: j
}, V), {
  transitions: {
    snap: "all 70ms cubic-bezier(0.2, 0.2, 0.38, 0.9)",
    fade: "all 110ms cubic-bezier(0.2, 0.2, 0.38, 0.9)",
    pop: "all 150ms cubic-bezier(0.4, 0.14, 0.3, 1)",
    callout: "all 240ms cubic-bezier(0.4, 0.14, 0.3, 1)"
  },
  zIndices: {
    "z-1": 0,
    "z-2": 100,
    "z-3": 200,
    "z-4": 300,
    "z-5": 400,
    "z-6": 500,
    "z-7": 600,
    "z-8": 700,
    "z-9": 800,
    "z-10": 900
  }
}),
    _i = i({
  prefix: "admin-ui"
}),
    L = _i.getCssText,
    M = _i.css,
    q = _i.keyframes,
    X = _i.globalCss,
    N = U.tablet,
    Y = U.desktop,
    J = U.widescreen;

var K = {
  bg: "background",
  fg: "color",
  "@tablet": "@media (min-width: ".concat(N, ")"),
  "@tabletOnly": "@media (min-width: ".concat(N, ") and (max-width: ").concat(Y, ")"),
  "@desktop": "@media (min-width: ".concat(Y, ")"),
  "@desktopOnly": "@media (min-width: ".concat(Y, ") and (max-width: ").concat(J, ")"),
  "@widescreen": "@media (min-width: ".concat(J, ")")
};

function Q(r) {
  var t = function (e) {
    var r = e.charAt(0),
        t = {
      "[": "&".concat(e),
      ":": "&".concat(e),
      ".": "& ".concat(e),
      "+": "& ".concat(e)
    }[r];
    return null != t ? t : e;
  }(r);

  return e(K, t, t);
}

var Z = {
  opacity: "opacities",
  transition: "transitions",
  border: "border",
  borderTop: "border",
  borderRight: "border",
  borderBottom: "border",
  borderLeft: "border",
  borderWidth: "borderWidths",
  borderStyle: "borderStyles",
  borderRadius: "borderRadius",
  borderTopRightRadius: "borderRadius",
  borderTopLeftRadius: "borderRadius",
  borderBottomRightRadius: "borderRadius",
  borderBottomLeftRadius: "borderRadius",
  borderTopWidth: "borderWidths",
  borderTopStyle: "borderStyles",
  borderBottomWidth: "borderWidths",
  borderBottomStyle: "borderStyles",
  borderLeftWidth: "borderWidths",
  borderLeftStyle: "borderStyles",
  borderRightWidth: "borderWidths",
  borderRightStyle: "borderStyles",
  borderBlock: "border",
  borderBlockEnd: "border",
  borderBlockEndStyle: "borderStyles",
  borderBlockEndWidth: "borderWidths",
  borderBlockStart: "border",
  borderBlockStartStyle: "borderStyles",
  borderBlockStartWidth: "borderWidths",
  borderBlockStyle: "borderStyles",
  borderBlockWidth: "borderWidths",
  borderEndEndRadius: "borderRadius",
  borderEndStartRadius: "borderRadius",
  borderInline: "border",
  borderInlineEnd: "border",
  borderInlineEndStyle: "borderStyles",
  borderInlineEndWidth: "borderWidths",
  borderInlineStart: "border",
  borderInlineStartStyle: "borderStyles",
  borderInlineStartWidth: "borderWidths",
  borderInlineStyle: "borderStyles",
  borderInlineWidth: "borderWidths",
  borderStartEndRadius: "borderRadius",
  borderStartStartRadius: "borderRadius",
  color: "fg",
  backgroundColor: "bg",
  background: "bg",
  borderColor: "borderColor",
  caretColor: "colors",
  columnRuleColor: "colors",
  borderTopColor: "borderColor",
  borderBottomColor: "borderColor",
  borderLeftColor: "borderColor",
  borderRightColor: "borderColor",
  fill: "colors",
  stroke: "colors",
  outlineColor: "colors",
  boxShadow: "shadow",
  textShadow: "shadow",
  zIndex: "zIndices",
  width: "sizes",
  minWidth: "sizes",
  maxWidth: "sizes",
  height: "sizes",
  minHeight: "sizes",
  maxHeight: "sizes",
  flexBasis: "sizes",
  blockSize: "sizes",
  inlineSize: "sizes",
  maxBlockSize: "sizes",
  maxInlineSize: "sizes",
  minBlockSize: "sizes",
  minInlineSize: "sizes",
  size: "sizes",
  minSize: "sizes",
  maxSize: "sizes",
  absoluteSize: "sizes",
  margin: "space",
  padding: "space",
  marginBlock: "space",
  marginBlockEnd: "space",
  marginBlockStart: "space",
  marginInline: "space",
  marginInlineEnd: "space",
  marginInlineStart: "space",
  paddingBlock: "space",
  paddingBlockEnd: "space",
  paddingBlockStart: "space",
  paddingInline: "space",
  paddingInlineEnd: "space",
  paddingInlineStart: "space",
  scrollPadding: "space",
  inset: "space",
  insetBlock: "space",
  insetBlockEnd: "space",
  insetBlockStart: "space",
  insetInline: "space",
  insetInlineEnd: "space",
  insetInlineStart: "space",
  gridGap: "space",
  gap: "space",
  columnGap: "space",
  rowGap: "space",
  gridColumnGap: "space",
  marginRight: "space",
  marginLeft: "space",
  marginX: "space",
  paddingRight: "space",
  paddingLeft: "space",
  paddingX: "space",
  scrollPaddingRight: "space",
  scrollPaddingLeft: "space",
  scrollPaddingX: "space",
  right: "space",
  left: "space",
  gridRowGap: "space",
  marginTop: "space",
  marginBottom: "space",
  marginY: "space",
  paddingTop: "space",
  paddingBottom: "space",
  paddingY: "space",
  scrollPaddingTop: "space",
  scrollPaddingBottom: "space",
  scrollPaddingY: "space",
  top: "space",
  bottom: "space",
  text: "text",
  fontFamily: "fonts",
  fontSize: "fontSizes",
  lineHeight: "lineHeights",
  letterSpacing: "letterSpacings",
  fontVariationSettings: "fontWeights"
};
var _ = {
  marginX: function marginX(e) {
    return {
      marginLeft: e,
      marginRight: e
    };
  },
  marginY: function marginY(e) {
    return {
      marginTop: e,
      marginBottom: e
    };
  },
  paddingX: function paddingX(e) {
    return {
      paddingLeft: e,
      paddingRight: e
    };
  },
  paddingY: function paddingY(e) {
    return {
      paddingTop: e,
      paddingBottom: e
    };
  },
  size: function size(e) {
    return {
      width: e,
      height: e
    };
  },
  minSize: function minSize(e) {
    return {
      minWidth: e,
      minHeight: e
    };
  },
  maxSize: function maxSize(e) {
    return {
      maxWidth: e,
      maxHeight: e
    };
  },
  absoluteSize: function absoluteSize(e) {
    return {
      minWidth: e,
      minHeight: e,
      maxWidth: e,
      maxHeight: e
    };
  },
  text: function text(e) {
    return {
      fontFamily: e.fontFamily,
      fontVariationSettings: e.fontVariationSettings,
      fontSize: e.fontSize,
      lineHeight: e.lineHeight,
      letterSpacing: e.letterSpacing
    };
  },
  colorTheme: function colorTheme(e) {
    return v(e);
  }
};

function ee(r, t) {
  return e(_, r, function () {})(t);
}

var re = {
  colorNamespaces: ["bg", "border", "fg", "shadows"],
  reservedNamespaces: ["global", "modes", "shadows", "sizes", "space", "hspace", "vspace", "breakpoints", "transitions", "border", "zIndices", "borderRadius"],
  prefix: "admin-ui",
  mainModeLabel: "main",
  rootElement: "body"
},
    te = function te(e) {
  return "--".concat(re.prefix, "-").concat(e);
},
    ae = function ae(e, r) {
  return "var(".concat(te(e)).concat(r ? ", ".concat(r) : "", ")");
},
    ie = function ie() {
  for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    e[_key2] = arguments[_key2];
  }

  return e.filter(Boolean).join("-");
};

function ne(e, r) {
  var t = Array.isArray(e) ? [] : {};

  for (var _a in e) {
    var _i2 = e[_a],
        _n = ie(r, _a);

    _i2 && "object" == typeof _i2 ? t[_a] = ne(_i2, _n) : t[_a] = ae(_n);
  }

  return t;
}

function oe(r, t, a) {
  if (!re.colorNamespaces.includes(t)) return r;
  var i = e(a, "colors", {}),
      n = Object.keys(i);
  var o = r;
  return n.forEach(function (r) {
    var t = e(i, r);
    o.includes(t) && (o = o.replace(new RegExp(t, "g"), ae("colors-".concat(r))));
  }), o;
}

function se(e) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  var a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
  var i = {},
      n = !a,
      o = n ? e : r;

  for (var _r in e) {
    var _s = n ? _r : t,
        _c = ie(a, _r),
        _l = e[_r];

    _l && "object" == typeof _l ? Object.assign(i, se(_l, o, _s, _c)) : Object.assign(i, _defineProperty({}, te(_c), oe(_l, _s, o)));
  }

  return i;
}

var _ref = function (a) {
  if (!a) return {
    theme: {
      global: {}
    },
    cssVariables: {}
  };

  var i = e(a, "global", {}),
      _ref2 = function (e) {
    return {
      dynamicTheme: r(e, re.reservedNamespaces),
      staticTheme: t(e, re.reservedNamespaces)
    };
  }(a),
      n = _ref2.staticTheme,
      o = _ref2.dynamicTheme,
      s = ne(o),
      c = se(o);

  return {
    theme: Object.assign(Object.assign({
      global: i
    }, s), n),
    cssVariables: c
  };
}(G),
    ce = _ref.theme,
    le = _ref.cssVariables,
    de = {
  padding: !0,
  margin: !0
};

function ge() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ce;
  var t = {};

  for (var _i3 in e) {
    var _n2 = Q(_i3),
        _o = e[_i3],
        _s2 = a(_o) ? _o(r, _n2) : _o;

    if (_s2 && "object" == typeof _s2) {
      t[_n2] = ge(_s2, r);
      continue;
    }

    var _c2 = me(r, _n2, _s2);

    _n2 in _ ? Object.assign(t, ee(_n2, _c2)) : t[_n2] = _c2;
  }

  return t;
}

function pe(r, t) {
  var a = z(r);
  return e(t, a, a);
}

function me(r, t, a) {
  var i = function (r, t) {
    var a = e(Z, r);
    return e(t, a, e(t, r, {}));
  }(t, r),
      n = function (e, r) {
    return e in de && "string" == typeof r;
  }(t, a) ? function (e, r) {
    return e.split(" ").map(function (e) {
      return pe(e, r);
    }).join(" ");
  }(a, i) : pe(a, i);

  return n;
}

function $e(e) {
  return function (r) {
    var t = ge(r, e);
    return M(t)().toString();
  };
}

var ue = $e(ce);

function be(e) {
  return e;
}

function ye(r) {
  return function (t) {
    var a = {};

    for (var _i4 in t) {
      Object.assign(a, e(r, "".concat(_i4, ".").concat(e(t, _i4)), {}));
    }

    return a;
  };
}

function fe(e) {
  return function (r, t) {
    return "-".concat(me(r, t, e));
  };
}

function he(e, r) {
  if ("string" == typeof e) return "[data-".concat(e, "=\"").concat(String(null != r ? r : ""), "\"]");
  return Object.keys(e).reduce(function (r, t) {
    return "".concat(r, "[data-").concat(t, "=\"").concat(String(e[t]), "\"]");
  }, "");
}

export { l as asLiterals, g as bgTokens, H as border, f as borderRadiusTokens, m as borderTokens, S as color, d as colorTokens, $e as createCsx, M as css, le as cssVariables, ue as csx, E as cx, he as dataAttr, y as elevationTokens, z as extractTokenCall, p as fgTokens, k as focusVisible, L as getCssText, me as getTokenValue, X as globalCss, C as isToken, q as keyframes, B as listBoxItem, fe as negative, v as palette, c as paletteMap, h as ring, $ as shadowTokens, b as spaceTokens, be as style, ye as styleVariants, ge as styles, u as textTokens, ce as theme, G as tokens, s as tones, F as withUnit };